import { AVO_EVENT_NAMES } from "avo/eventNames";
import React, { useContext, useState } from "react";
import { sendEventUsingAvo } from "./events";

interface IAuthSignintate {
    sendEvent: (clickedOn:string) => void;
    showQRPopup: boolean;
    setShowQRPopup: React.Dispatch<React.SetStateAction<boolean>>
    getFromPage: () => string | null;
};

const AuthSigninContext = React.createContext({} as IAuthSignintate);

const AuthSigninProvider = ({ children }: any) => {

    const [showQRPopup, setShowQRPopup] = useState(false);

    const sendEvent = (clickedOn: string) => {
        sendEventUsingAvo({
          eventName: AVO_EVENT_NAMES.interactedLoginScreen,
          props: {
            clickedOn
          }
        })
      }

    const getFromPage = () => {
    if (window.location.hash.includes('?')) {
        const queryString = window.location.hash.split('?')[1];
        const urlParams = new URLSearchParams(queryString);
        const fromPage = urlParams.get('fromPage');
        if (fromPage) {
        return decodeURIComponent(fromPage);
        }
    }
    return null;
    }

    const AuthSigninState: IAuthSignintate = {
        sendEvent,
        showQRPopup,
        setShowQRPopup,
        getFromPage,
    };
    return (
        <AuthSigninContext.Provider value={AuthSigninState}>
            { children } 
        </AuthSigninContext.Provider>
    );
}

export const useAuthSigninState = () => {
    const context = useContext(AuthSigninContext);
    if (!context) {
        throw Error(`Use ${useAuthSigninState.name} in ${AuthSigninContext.displayName}`);
    }
    return context;
};

export default AuthSigninProvider;